const phases = [
  {
    icon: 'ri-heart-pulse-line',
    title: 'HEALED',
    body: 'Stabilising the nervous system. Safety, containment, somatic awareness, emotional regulation, survival patterns.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'OWNED',
    body: 'Claiming sovereignty. Mother wound, father wound, authority, worth, inner leadership, self responsibility.',
  },
  {
    icon: 'ri-heart-3-line',
    title: 'MET',
    body: 'Deep internal intimacy. Worth, self-love, internal validation, money, safety, scarcity, shadow, power, desire.',
  },
  {
    icon: 'ri-magic-line',
    title: 'EMBODIED',
    body: 'Living the work. Womb work, feminine safety, new relational patterns, integration, closure, continuity.',
  },
];

const bonuses = [
  'The anatomy of belief',
  'The emotional alchemy guide',
  'The nervous system toolkit',
  'Daily affirmation practice (Monday through Sunday ritual)',
  'Art pages for self-expression',
];

export default function PhasesSection() {
  return (
    <section className="bg-[#FDFAF8] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4 text-center">
          The healing journey inside
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#1A1A1A] text-center mb-14 leading-tight">
          Every page. Every card. Written with one woman in mind. You.
        </h2>

        {/* 4 Phase Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto mb-16">
          {phases.map((phase, index) => (
            <div
              key={phase.title}
              className="bg-[#FDFAF8] border border-[#C9A84C]/20 rounded-lg p-5 md:p-8 flex flex-col"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i className={`${phase.icon} text-2xl text-[#C9A84C]`} />
              </div>
              <h3 className="font-heading text-lg text-[#1A1A1A] mb-3">
                {phase.title}
              </h3>
              <p className="font-body text-xs text-[#5A5A5A] leading-relaxed">
                {phase.body}
              </p>
              <div className="mt-4 text-[#C9A84C] text-xs font-body font-medium">
                Phase {index + 1}
              </div>
            </div>
          ))}
        </div>

        {/* Also Included — gold bullets */}
        <div className="max-w-3xl mx-auto">
          <h3 className="font-heading text-lg text-[#1A1A1A] mb-6 text-center">
            Also included
          </h3>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3">
            {bonuses.map((bonus) => (
              <div key={bonus} className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-[#C9A84C]" />
                <span className="font-body text-sm text-[#4A4A4A]">{bonus}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}